import React from "react"

import { openCustomURL } from "@/utils/location"

import styles from "./DiyRate.module.scss"

type IPerson = {
  starNum: number
}
const count: IPerson = {
  starNum: 5,
}

export interface IProps {
  onSelected(rating: number): void
  url: string
}

// 星星
export default function (props: IProps) {
  const contList = () => {
    const cont = []

    for (let i = count.starNum; i >= 1; i--) {
      cont.push(i)
    }
    return cont
  }

  const rate = (e: any) => {
    const $radio = e.target || e.path[0],
      val = $radio.value || -1

    $radio.checked = false // 每当用户点击后都取消星星选中
    if (val === -1) return
    props.onSelected(parseInt(val))
    if (parseInt(val) === 5) {
      openCustomURL(props.url)
    }
  }

  return (
    <div>
      <div className={styles.container}>
        <div className={styles.rateContent}>
          {contList().map((o) => {
            return (
              <input
                key={o}
                onClick={rate}
                value={o}
                name="rate"
                type="radio"
              />
            )
          })}
        </div>
      </div>
    </div>
  )
}
